export default __webpack_public_path__ + "static/media/video.5e148c47.mp4";